import { Moment } from 'moment'

import { IDateRange } from '../types'

export const getStartAndEndDate = (
  date: Moment,
  period: number,
): IDateRange => {
  switch (period) {
    case 7:
      return {
        start: date.clone().startOf('isoWeek'),
        end: date.clone().endOf('isoWeek'),
      }
    default:
      return {
        start: date.clone().startOf('day'),
        end: date
          .clone()
          .startOf('day')
          .add(period - 1, 'days')
          .endOf('day'),
      }
  }
}
